module.exports = __webpack_public_path__ + "static/media/amenities_1.e5f8ad56.svg";